import React, { useEffect, useState } from "react";
import {
  TextField,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import { API_get_vendor_att } from "../utils/http";
import VendorService from "./VendorService";
import Navbar from "./Navbar";

const sectionCard = {
  padding: "12px 16px",
  marginBottom: "16px",
  borderRadius: "10px",
  backgroundColor: "#fff",
  boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
  border: "1px solid #E0E0E0",
};

export default function VendorInput(props) {
  let init_data_null = {
    code: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    type: "",
  };
  const [data_vendor_att, set_data_vendor_att] = useState(null);

  const HOTEL = "hotel";
  const TRANS = "transportation";
  const TOUR = "tour";
  const FLIGHT = "flight";
  const CRUISE = "cruise";

  const [init_data, set_init_data] = useState(
    props.init_data == null ? init_data_null : props.init_data
  );

  function get_data_vendor_att() {
    API_get_vendor_att(props.init_data._id, (data_org) => {
      set_data_vendor_att(data_org);
    });
  }

  useEffect(() => {
    get_data_vendor_att();
  }, []);

  const typeOptions = [
    { value: HOTEL, label: "Hotel" },
    { value: FLIGHT, label: "Flight" },
    { value: TOUR, label: "Tour" },
    { value: TRANS, label: "Transportation" },
    { value: CRUISE, label: "Cruise" },
  ];

  return (
    <Box>
      <Navbar
        title={props.init_data == null ? "Create vendor" : "Edit vendor"}
        onGoBack={() => props.onGoBackClick()}
        onSave={() => props.onSaveClick(props.init_data._id, init_data)}
      />
      <Box sx={{ padding: "16px 20px" }}>
        {/* Vendor info card */}
        <Box sx={sectionCard}>
          <Typography sx={{ fontWeight: 600, fontSize: 15, mb: 1.5 }}>
            Vendor Information
          </Typography>
          {/* Type chips */}
          <Box sx={{ display: "flex", gap: 0.75, mb: 1.5 }}>
            {typeOptions.map((opt) => (
              <Chip
                key={opt.value}
                label={opt.label}
                size="small"
                onClick={() =>
                  set_init_data({ ...init_data, type: opt.value })
                }
                sx={{
                  fontWeight: 500,
                  fontSize: 12,
                  ...(init_data.type === opt.value
                    ? { backgroundColor: "#1976D2", color: "#fff" }
                    : { backgroundColor: "#F5F7FA", color: "#555" }),
                }}
              />
            ))}
          </Box>
          {/* Fields */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                size="small"
                label="Code"
                value={init_data.code}
                onChange={(e) =>
                  set_init_data({ ...init_data, code: e.target.value })
                }
                sx={{ flex: 1 }}
              />
              <TextField
                size="small"
                label="Name"
                value={init_data.name}
                onChange={(e) =>
                  set_init_data({ ...init_data, name: e.target.value })
                }
                sx={{ flex: 2 }}
              />
              <TextField
                size="small"
                label="Phone"
                value={init_data.phone}
                onChange={(e) =>
                  set_init_data({ ...init_data, phone: e.target.value })
                }
                sx={{ flex: 1 }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                size="small"
                label="Email"
                value={init_data.email}
                onChange={(e) =>
                  set_init_data({ ...init_data, email: e.target.value })
                }
                sx={{ flex: 1 }}
              />
              <TextField
                size="small"
                label="User receive email"
                value={init_data.user_receive_email}
                onChange={(e) =>
                  set_init_data({
                    ...init_data,
                    user_receive_email: e.target.value,
                  })
                }
                sx={{ flex: 1 }}
              />
              <TextField
                size="small"
                label="Address"
                value={init_data.address}
                onChange={(e) =>
                  set_init_data({ ...init_data, address: e.target.value })
                }
                sx={{ flex: 1 }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                size="small"
                label="Mail CC 1"
                value={init_data.mail_cc_1}
                onChange={(e) =>
                  set_init_data({ ...init_data, mail_cc_1: e.target.value })
                }
                sx={{ flex: 1 }}
              />
              <TextField
                size="small"
                label="Mail CC 2"
                value={init_data.mail_cc_2}
                onChange={(e) =>
                  set_init_data({ ...init_data, mail_cc_2: e.target.value })
                }
                sx={{ flex: 1 }}
              />
              <TextField
                size="small"
                label="Mail CC 3"
                value={init_data.mail_cc_3}
                onChange={(e) =>
                  set_init_data({ ...init_data, mail_cc_3: e.target.value })
                }
                sx={{ flex: 1 }}
              />
            </Box>
          </Box>
        </Box>

        {/* Vendor services */}
        {data_vendor_att == null ? null : (
          <VendorService
            vendorType={init_data.type}
            vendorGroupID={props.init_data._id}
            activ={props.activ}
            accom={props.accom}
            data={data_vendor_att}
            get_data_vendor_att={() => get_data_vendor_att()}
          />
        )}
      </Box>
    </Box>
  );
}
